import assetApi from 'api/assetApi';
import coinApi from 'api/coinApi';
import { AssetResponseModel, Coin } from 'models/asset';
import { useState } from 'react';
import { useHandleResponseError } from './useHandleResponseError';
import walletApi from 'api/walletApi';
import { useDispatch } from 'react-redux';
import {
  selectAssets,
  selectCurrentCurrency,
  selectCurrentWallet,
  selectUserWallets,
  setBlance,
  setCurrentWallet,
  setTransferBalance,
  setUserWallets,
} from 'features/home/homeSlice';
import BigNumber from 'bignumber.js';
import { useAppSelector } from 'app/hooks';

export const useHandleGetWallets = () => {
  const handleResponseError = useHandleResponseError();
  const [coins, setCoins] = useState<Coin[]>([]);
  const [assets, setAssests] = useState<AssetResponseModel[]>([]);
  const dispatch = useDispatch();
  const currentCurrency = useAppSelector(selectCurrentCurrency);
  const currentWallet = useAppSelector(selectCurrentWallet);
  const userWallets = useAppSelector(selectUserWallets);
  const assetList = useAppSelector(selectAssets);

  const getCoins = async () => {
    const { ok, body, error } = await coinApi.getCoins();

    if (ok && body) {
      setCoins(body);
    }

    if (error) handleResponseError(error);
  };

  const getAssets = async () => {
    const { ok, body, error } = await assetApi.getAssets();
    if (ok && body) {
      setAssests(body);
    }

    if (error) handleResponseError(error);
  };

  const getWallet = async () => {
    const { ok, body, error } = await walletApi.getWallets();

    if (ok && body) {
      dispatch(setUserWallets(body));
      const wallet = body.find((w) => w.coin.symbol === currentCurrency);
      if (wallet) {
        const transferBalance = new BigNumber(wallet.balance).minus(
          new BigNumber(wallet.promotionBalance),
        );
        dispatch(setTransferBalance(transferBalance.toString()));
        dispatch(setBlance(wallet.balance));
        dispatch(setCurrentWallet(wallet));
      }
    }

    if (error) {
      handleResponseError(error);
    }
  };

  const fetchData = async () => {
    await getCoins();
    await getAssets();
  };

  const usdBalance = () => {
    if (userWallets) {
      const usdWallet = userWallets.find((wallet) => wallet.coin.symbol === 'USD');
      return usdWallet ? usdWallet.balance : 0;
    }
    return 0;
  };

  const tbetBalance = () => {
    if (userWallets) {
      const usdWallet = userWallets.find((wallet) => wallet.coin.symbol === '$TBET');
      return usdWallet ? usdWallet.balance : 0;
    }
    return 0;
  };

  const getAssetByCoinAndChain = (coinSymbol: string, chainSymbol: String) => {
    if (assetList) {
      return assetList.find((a) => a.chain.symbol === chainSymbol && a.coin.symbol === coinSymbol);
    }
    return null;
  };

  return {
    coins,
    assets,
    fetchData,
    getWallet,
    currentWallet,
    userWallets,
    usdBalance,
    tbetBalance,
    getAssetByCoinAndChain,
  };
};
